import pic_01 from './Assets/pic_01.webp';
import pic_02 from './Assets/pic_02.webp';
import pic_03 from './Assets/pic_03.webp';
import pic_04 from './Assets/pic_04.webp';
import pic_05 from './Assets/pic_05.webp';
import pic_06 from './Assets/pic_06.webp';
import pic_07 from './Assets/pic_07.webp';
import pic_08 from './Assets/pic_08.webp';
import pic_09 from './Assets/pic_09.webp';
import pic_10 from './Assets/pic_10.webp';
import pic_11 from './Assets/pic_11.webp';
import pic_12 from './Assets/pic_12.webp';
import ambassadorImage from './Assets/SnowfallSummit.png';

export const ambassador = {
  name: 'Snowfall Summit',
  position: 'right',
  description: <>
    <p>
      Once upon a time, in a small creative studio in the U.S., a dreamer named Snow poured a passion for Japanese culture and anime into a budding YouTube channel. That spark grew into Snowfall Summit, a vibrant hub for 2D/3D anime-style animations and gaming content. As subscribers soared past 780,000 and total views exceeded 200 million – mostly from fans in the U.S. and Canada – Snow pushed the boundaries of digital storytelling with each new upload. Today, videos on Snowfall Summit often gather millions of views, sometimes skyrocketing beyond 18 million, connecting a global community through shared love of pop culture and imaginative adventures. Through every animation and gaming narrative, Snow remains committed to celebrating anime’s influence, uniting fans in a world where creativity knows no limits.
    </p>
  </>,
  image: ambassadorImage,
  socialLinks: {
    instagram: 'https://www.instagram.com/snowfallsummit/',
    youtube: 'https://www.youtube.com/@SnowfallSummit',
    tiktok: 'https://www.tiktok.com/@snowfallsummit',
  },
};

export const EpochInfo = {
  title: 'INSTAGRAMINISM',
  period: '2010 - present',
  description: <>
    <p>Instagraminism is a vibrant movement in today's digital photo and video culture, dedicated to the authentic representation of observed reality. Emerging in the early 2010s and continuing to evolve, it serves as a mirror reflecting the social issues and preferences of contemporary society.</p>
    <p>Initially, Instagraminism aimed to reproduce reality without the artistic embellishment, critical interpretation, or extensive curation often associated with traditional art forms. However, as the movement matured, it experienced a fascinating transformation. The focus shifted toward creative concepts, aesthetics, and unconventional ideas, embracing emotions and personal impressions.</p>
    <p>Today, Instagraminism plays a pivotal role in shaping trends across various fields, including fashion, cooking, travel, art, and even motherhood.</p>
  </>,
};

export const events = [
  {
    year: '2010',
    title: 'Who was first?',
    content: (
      <>
        <p>
          In 2010, Mike Krieger and Kevin Systrom launched Instagram, a simple photo-sharing app that would soon evolve into one of the world’s largest social networks. On June 16 of that year, the founders made their very first post, sparking a friendly debate about whose photo hit the feed first: Mike’s shot of Pier 38 at South Beach Harbor or Kevin’s whimsical snapshot of his girlfriend’s foot alongside an adorable dog, simply captioned "test."
        </p>
        <p>
          But by the following year, the debate became a footnote in history, as Instagram celebrated a staggering milestone — 1 million registered users!
        </p>
      </>
    ),
    img: pic_01,
    blurhash: '|DFPsrIV9$IVxu%1-oxsadAhem-njEM|RmMxW=R.%iWX%0xuWBbcoLaet7Iv%KNHWAflRPbcRjof4pt5bIRjS6ofRjaeRlIVoJoeozM{WCofbIt5IqWBjExaR*R+RjRkRkV^t6bHt7xqW?RjofjZfORjWBRjt6V@R.Rjof',
    picName: 'pic_01',
  },
  {
    year: '2013',
    title: 'Oscar-Winning Selfie',
    content: (
      <>
        <p>
          In 2013, "selfie" officially entered the Oxford Dictionary, defined as "a photo of yourself taken typically with a smartphone or webcam, often shared on social media." This term reached new heights of popularity when Ellen DeGeneres snapped a selfie at the 86th Oscars alongside several nominees. This iconic photo quickly became legendary, racking up an astounding 2 million retweets before the ceremony even wrapped up!
        </p>
      </>
    ),
    img: pic_02,
    blurhash: '|IG@}dRjtRWCRhRkRooenzC,xZt7R+$fS4JBbbr=IXt6%1o1XSjERjsmj[rC$%SwSNbwS4rrR+NxI=ozsls-nmxDX4WBRQkXn+xDxZNakCsUR+M|ocWqOXozi{s:RkjFkCM{R+sCayNIofocbbxZ$%r?WCR*R*ofjtxZbb',
    picName: 'pic_02',
  },
  {
    year: '2013-2014',
    title: 'Selfie Revolution',
    content: (
      <>
        <p>
          Selfies have become a dominant form of online photography, leading to the emergence of various categories. The Elevator Look captures spontaneous self-portraits in mirrors, while the Duckface is an iconic style that needs no introduction. The Wake-Up Selfie features a casually tousled look, as if just rolled out of bed, and the Bathroom Look is a classic candid shot in front of a bathroom mirror. For the bold, Extreme Selfies showcase daring moments at dizzying heights or locations.
        </p>
        <p>
          A standout trend from spring 2014 is the Sellotape Selfie, which involves wrapping scotch tape around one’s face. Inspired by a scene from "Always Say Yes" featuring Jim Carrey, University of Brighton student Lizzie Durley put her own spin on this quirky style.
        </p>
        <p>
          These categories reflect the diverse and creative ways people express themselves through selfies in the ever-evolving landscape of social media.
        </p>
      </>
    ),
    img: pic_03,
    blurhash: '|9H1e}tm1w-o0M^u9ZS%tS%$OAIonP]}r=VsS#=E?[O9IVE3IWv}%FR6EOCkNNx[tPv#S^#8a$nOI:nOJCV{$ebv-otPxZ%3r^WokTIqNZxBV[XR1ORj,oSin+WUoewIrXjeM{$esoEgw^t7ogn$b]ozn$tQW@oexZRkt3',
    picName: 'pic_03',
  },
  {
    year: '2014',
    title: 'Belfie',
    content: (
      <>
        <p>
          Regular selfies faced some stiff competition when the 'belfie' (a mix of 'selfie' and 'butt') burst onto the scene, courtesy of Kim Kardashian. Kim's belfies became an instant Instagram sensation, with celebrities quickly jumping on the trend. A year later, Kim set the internet on fire again—this time, with a bold series of selfies showing her pregnant and completely nude.
        </p>
        <p>
          Not to be outdone, the guys soon joined in with their own take: the 'melfie' (man selfie). But don't expect glamorous angles — only self admiration, only muscles, only hardcore.
        </p>
      </>
    ),
    img: pic_04,
    blurhash: '|AGkzC~VLI4U004:_2%KyC.k%1}TIWNfxa-;obRPtSxaH@D%RjRkx[bci{v#Rj0fRP%0o}kqozRPJRRQRPM|ozxajsoLWBs:ofkCs:bcofnij?X8$$xtNIxt%2ozWBk9WBb^oMsAWBf*kBt6WDoMjYk9IpkBo0t6ayRkoM',
    picName: 'pic_04',
  },
  {
    year: '2014',
    title: 'We’re All Sick!',
    content: (
      <>
        <p>
          Psychiatrists introduced a new term, "selfitis," to describe an obsessive-compulsive disorder characterized by a relentless urge to take selfies and share them on social media. This behavior is often associated with low self-esteem, as individuals use constant posting to fill that emotional gap.
        </p>
      </>
    ),
    img: pic_05,
    blurhash: '|5BC=9-:00D*D*%2o}bvxtS4Rks,tQ-oIp9bt6NG00D+^*-:ozIUn5aeoLOs%Le:D*4p%2~UR*xZ9at7oMD*%L-;o|ni9aQ-IptR-o?F%1E2NGs:?Gi{Wq%MRPE1Ipoy^%tRWBRPt7T09anNt7NdNdxar=NHWXsloJRkM|',
    picName: 'pic_05',
  },
  {
    year: '2015',
    title: 'Selfie Rock Star',
    content: (
      <>
        <p>
          The Guinness World Record for the most selfies is held by none other than Dwayne 'The Rock' Johnson, the American actor and professional wrestler. In a stunning display of fan interaction, The Rock took 105 selfies with fans in just three minutes during the premiere of his movie San Andreas in April 2015!
        </p>
      </>
    ),
    img: pic_06,
    blurhash: '|6A+{vDi00~qM{IA^+NL9F[9Oa5:rXt6t2nPWYXmt-MxIUyBslMyo}s.MxM|xuxWIVt7S%IVxstRIpofoes:xHM{W;s,WUNLWAk8s:xbWYV[tRRjMwogt7M|NHt6V[aKxu%MsmadoyS2RjkBbbsVIAt7tRMyoKxuM{WBbb',
    picName: 'pic_06',
  },
  {
    year: '2015-2016',
    title: '#FAKE',
    content: (
      <>
        <p>
          In 2015, influencer marketing exploded into a $1 billion industry, with brands jumping on board to use it for promotions and raising awareness about important issues.
        </p>
        <p>
          Take the summer of 2016, for example. A fictional character named Louise Delage took Instagram by storm. Within a month, she racked up 65,000 followers, sharing pictures of her chilling in parks, splashing around in pools, and soaking up the sun on a yacht. It all seemed perfect until a video revealed that Louise was actually a creation of the ad agency BETC for Addict Aide, which aimed to raise awareness about alcoholism. The Like My Addiction campaign showed how easy it is to miss the signs of addiction, with Louise often holding drinks in her photos. After the video dropped, the hashtag #louisedelege went viral.
        </p>
        <p>
          A year later, a U.S. marketing agency pulled off a similar stunt, creating fake accounts for a fashion model called callmebagchick310 and a travel photographer named wanderinggirll. They used stock photos and bought fake followers, and guess what? They snagged brand offers for both accounts! The Medialix team later shared the story to remind brands to be careful when choosing influencers.
        </p>
      </>
    ),
    img: pic_07,
    blurhash: '|FCZhVI94T.8M|-;RkWBNH_NRjMxt8NdtRM{WCozOENHn%s,RjbvbHjFt7VrR-S5odj@V@t8a}WBDixu%MRPS2niofbIayjEjsogoLjFj?bIaejts8s:X8WBs:s.WBfka}aebca#RibIoga}oLWCs.NHbIxaaeR*X8oeoL',
    picName: 'pic_07',
  },
  {
    year: '2019',
    title: 'The Story of an Egg Named Eugene',
    content: (
      <>
        <p>
          Once hailed as the most popular post in online history, the famous egg known as Eugene had a moment of vulnerability. Feeling the weight of global attention, it cracked open to reveal a powerful message: the importance of mental health. Accompanying the cracked egg was a heartfelt reminder for anyone struggling to reach out for help.
        </p>
        <p>
          On December 20, 2022, however, Eugene's reign came to an end when Lionel Messi celebrated his World Cup victory with a post that stole the spotlight.
        </p>
        <p>
          Then, in the spring of 2023, the iconic egg mysteriously vanished from its Instagram feed, replaced by a new image — one that no longer featured the egg. It looks like to uncover the fate of Eugene, users will need to break a new record and outshine Messi.
        </p>
      </>
    ),
    img: pic_08,
    blurhash: '|NNc[:?GxtoeIVt7xaRkRk~VjZM|t6xaWCRkofof01WVoLWCoLWBj@ofay_2j[xtWBM|t6t6RkWB9aWCM|oextWBRkj[of-:oet6j[R*WBofofWCIVayayayj[ofWCWBj[t7ofWCWCoeayazj[ayjZWBofofWBayj[oeay',
    picName: 'pic_08',
  },
  {
    year: '2023',
    title: 'TOP 40',
    content: (
      <>
        <p>
          In recent years, the top 40 most-followed Instagram accounts have seen surprisingly little change, with only a few occasional shifts in ranking. Here’s a look at the lineup in 2023:
        </p>
        <ul>
          <li>40: Priyanka Chopra — 88.8 million followers</li>
          <li>39: Vin Diesel — 89.9 million followers</li>
          <li>38: NASA — 61 million followers</li>
          <li>37: Dua Lipa — 89.5 million followers</li>
          <li>36: Gal Gadot — 89 million followers</li>
          <li>35: UEFA Champions League — 35.5 million followers</li>
          <li>34: Billie Eilish — 108 million followers</li>
          <li>33: FC Barcelona — 109 million followers</li>
          <li>32: Drake — 131 million followers</li>
          <li>31: Chris Brown — 117 million followers</li>
          <li>30: Ellen DeGeneres — 114 million followers</li>
          <li>29: Real Madrid — 118 million followers</li>
          <li>28: Rihanna — 146 million followers</li>
          <li>27: LeBron James — 124 million followers</li>
          <li>26: Demi Lovato — 115 million followers</li>
          <li>25: Cardi B — 130 million followers</li>
          <li>24: Kevin Hart — 144 million followers</li>
          <li>23: Zendaya — 145 million followers</li>
          <li>22: Katy Perry — 108 million followers</li>
          <li>21: Miley Cyrus — 200 million followers</li>
          <li>20: Neymar — 206 million followers</li>
          <li>19: Nicki Minaj — 177 million followers</li>
          <li>18: Kourtney Kardashian — 207 million followers</li>
          <li>17: Jennifer Lopez — 380 million followers</li>
          <li>16: Virat Kohli — 284 million followers</li>
          <li>15: Taylor Swift — 292 million followers</li>
          <li>14: National Geographic — 248 million followers</li>
          <li>13: Nike — 233 million followers</li>
          <li>12: Kendall Jenner — 287 million followers</li>
          <li>11: Justin Bieber — 298 million followers</li>
          <li>10: Khloé Kardashian — 313 million followers</li>
          <li>9: Beyoncé — 329 million followers</li>
          <li>8: Kim Kardashian — 375 million followers</li>
          <li>7: Ariana Grande — 389 million followers</li>
          <li>6: Dwayne 'The Rock' Johnson — 412 million followers</li>
          <li>5: Selena Gomez — 429 million followers</li>
          <li>4: Kylie Jenner — 397 million followers</li>
          <li>3: Lionel Messi — 487 million followers</li>
          <li>2: Cristiano Ronaldo — 602 million followers</li>
          <li>1: Instagram (@instagram) — 651 million followers</li>
        </ul>
      </>
    ),
    img: pic_09,
    blurhash: '|WHwGd|FIbOZoaR-bFW.ni~B$eV_WYj?ShWVj?oJS#a$S4W-ofn+n%baWoX8S#j[sls:sonjjtay-7soWVjZbaa{njnjjbWXa}R*W=j]n$e:oKbFNyn%n~X8WYj?n$juR+ofslaxbbfRaxWoa}WVsooLaxbIj[bEWWayoJ',
    picName: 'pic_09',
  },
  {
    year: '2023',
    title: '$1,600,000',
    content: (
      <>
        <p>
          That’s the value of the most expensive advertising post on Instagram! Take a look at the Top 40, and it won’t be hard to guess who takes the crown — Portuguese soccer superstar Cristiano Ronaldo.
        </p>
      </>
    ),
    img: pic_10,
    blurhash: '|9Jj^.*epub_AC,qOsX7xF4R6~.lE%D4tkXmR+n%csS$z;Z%t8rrE1t7xu|@v~?aI:GtOYRPyCs9JQtQf5MerDR6Q-wdt5E*kCVZ%1t7axt+jGt7tkkWVtniJUR*yCj=M|RPrrODX7tRNGaJt7gNI:tQx[jFVtn%soRP%f',
    picName: 'pic_10',
  },
  {
    year: '2023',
    title: '#FollowMeTo',
    content: (
      <>
        <p>
          Murad and Natalia Osmann are the top travel influencers from Russia, and about 10 million people tune in to their adventures every day. A few years back, they kicked off the #FollowMeTo photo project, and now it has over 6 million followers on Instagram.
        </p>
      </>
    ),
    img: pic_11,
    blurhash: '|8FPB0xa_}Rj9~x[9co|EMyEogMcxD-.EMS$RPM{9wIpq]%goz$$acockVyE-ns,tQaL$zRRs8V[n3Nf.7%2+ux]M}RPNL,BNFJ7R*ofWUiwSgS6%#aL%1W=S~XR#*%1enTINHxWoytQM{ozj=r=V@RPkCniRPV[tkTJxV',
    picName: 'pic_11',
  },
  {
    year: '2023-2024',
    title: 'Threads: The Chat That Never Ends',
    content: (
      <>
        <p>
          Threads, the microblogging platform launched by Meta in July 2023, has seen notable growth in user engagement. As of August 2024, it has around 200 million monthly active users and about 33 million daily users.
        </p>
        <p>
          Threads reached 100 million signups in just five days, but average user time on the app has declined to about 10 minutes per day. With over 265 million downloads, Threads competes with X (formerly Twitter), which leads in overall engagement and daily activity.
        </p>
      </>
    ),
    img: pic_12,
    blurhash: '|WIEk2.l16M}RPadRjbFbI0fNF$zIqV[xCt5ofoyIusDxYS1NHV[s.ofoftkxDaLs:t6S5f6R-WXRjR+SOnislWnR+jbj[s:WXWVxZozofSNoLWCoyt5WVM}V[s.W;WCjuV@WBoyt7ShV[niWVafoyoeV[WBodkCoLjZjs',
    picName: 'pic_12',
  },
];